import React from 'react';

import BackButton from '../../../../../../components/back-button/back-button';
import Typography from '../../../../../typography/typography';
import { TabOption } from '../../../../fitment-types';
import FitmentCantFindAlternateShopOptions from '../fitment-cant-find-alternate-shop-options/fitment-cant-find-alternate-shop-options';

import { useMessage } from '../../../../../../shared/hooks/hooks';

import { DT_FITMENT_YOU_CAN_STILL_SHOP_MESSAGE } from '../../../../../../shared/constants/messages';

import './fitment-cant-find-thats-ok.scss';

interface FitmentCantFindThatsOkProps {
  hideShopBySize?: boolean;
  onBackClick: () => void;
  onShopByClick: (tab: TabOption) => void;
  showBackButton?: boolean;
}

function FitmentCantFindThatsOk(props: FitmentCantFindThatsOkProps) {
  const {
    hideShopBySize = false,
    onBackClick,
    onShopByClick,
    showBackButton = false
  } = props;

  const messages = useMessage([DT_FITMENT_YOU_CAN_STILL_SHOP_MESSAGE]) || {};

  return (
    <section data-testid="fitment-cant-find-thats-ok" styleName="container">
      {showBackButton && (
        <BackButton
          className="back-button"
          onClick={onBackClick}
          styleName="back-button"
          text="back"
        />
      )}
      <Typography styleName="title" variant="h4" weight="heavy">
        That’s ok!
      </Typography>
      {messages[DT_FITMENT_YOU_CAN_STILL_SHOP_MESSAGE] ? (
        <Typography
          dangerouslySetInnerHTML={{
            __html: messages[DT_FITMENT_YOU_CAN_STILL_SHOP_MESSAGE]
          }}
          styleName="message"
          tag="div"
        />
      ) : (
        <Typography styleName="message">
          You can still shop for your new tires by brand, tire size or even
          using your vehicle’s license plate number. At the store, we’ll verify
          that these tires fit safely.
        </Typography>
      )}
      <FitmentCantFindAlternateShopOptions
        hideShopBySize={hideShopBySize}
        onShopByClick={onShopByClick}
        styleName="ctas"
      />
    </section>
  );
}

export default FitmentCantFindThatsOk;
